<script>
  import { createEventDispatcher } from "svelte"

  export let title = ""
  export let message = ""
  export let index = 0
  export let cupon = "000000"
  export let tipo = ""

  let isClosed = false

  const closeAlert = () => {
    isClosed = true
  }

  const dispatch = createEventDispatcher()

  const deleteNotificacion = () => {
    dispatch("delete", {
      index: index,
    })
  }

  message =
    message +
    ` <style>
      p,li {
        margin-bottom:5px;
      }
    </style>`
</script>

{#if !isClosed}
<div
  class="alert theme-warning small"
  role="alert"
>
  <div class="flex-grow-1">
  {#if tipo == "descuento"}
    <h4 class="alert-heading fs-lg mb-5">(Desc-{cupon}) {title}</h4>
  {:else}
    <h4 class="alert-heading fs-lg mb-5">{title}</h4>
  {/if}

  {@html message}
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar notificación"
    on:click={closeAlert}
    on:click={deleteNotificacion}
  />
</div>
{/if}

<style>
  .alert.theme-warning {
    background-color: #fff6eb;
    border-color: #ff7800;
    color: #a84f00;
  }
</style>
